import {connect} from "react-redux";
import MapPopup from "./MapPopup";
import {excludeCity, excludePassthroughPoint} from "../../store/actions";

const mapStateToProps = state => ({
    
});

const mapDispatchToProps = dispatch => ({
  excludeCity: city => dispatch(excludeCity(city)),
  excludePassthroughPoint: index => dispatch(excludePassthroughPoint(index))
});

export default connect(
    mapStateToProps,
    mapDispatchToProps,
)(MapPopup);